import React from 'react';

const iconProps = {
  width: 16,
  height: 16,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

const MonitorIcon = () => (
  <svg {...iconProps}>
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M8 20h8M12 16v4" />
  </svg>
);

const MessagesIcon = () => (
  <svg {...iconProps}>
    <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" />
  </svg>
);

const AccountIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-3.5 3.6-6 8-6s8 2.5 8 6" />
  </svg>
);

const JobDescriptionIcon = () => (
  <svg {...iconProps}>
    <path d="M14 2H7a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6M9 13h6M9 17h4" />
  </svg>
);

const CreateAccountsIcon = () => (
  <svg {...iconProps}>
    <circle cx="9" cy="8" r="3.5" />
    <path d="M2.5 19c0-2.8 2.9-5 6.5-5s6.5 2.2 6.5 5" />
    <path d="M19 8v6M16 11h6" />
  </svg>
);

const InterviewersIcon = () => (
  <svg {...iconProps}>
    <circle cx="9" cy="8" r="3.2" />
    <circle cx="17" cy="9" r="2.6" />
    <path d="M2.5 19c0-2.7 2.9-4.8 6.5-4.8 1.3 0 2.5.3 3.5.8" />
    <path d="M14 19c0-2 1.8-3.6 4.2-3.6 2.2 0 4 1.4 4 3.6" />
  </svg>
);

const OnHoldIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M10 8v8M14 8v8" />
  </svg>
);

const JobOfferIcon = () => (
  <svg {...iconProps}>
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M3 12h18" />
  </svg>
);

const HiredIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M8.5 12.5l2.5 2.5 4.5-5" />
  </svg>
);

const PoolingIcon = () => (
  <svg {...iconProps}>
    <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" />
    <path d="M12 12l8-4.5M12 12v9M12 12L4 7.5" />
  </svg>
);

const PassedInterviewIcon = () => (
  <svg {...iconProps}>
    <path d="M9 11l3 3L22 4" />
    <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
  </svg>
);

const FailedInterviewIcon = () => (
  <svg {...iconProps}>
    <circle cx="12" cy="12" r="9" />
    <path d="M15 9l-6 6M9 9l6 6" />
  </svg>
);

const RetractedIcon = () => (
  <svg {...iconProps}>
    <path d="M9 14H4v-5" />
    <path d="M4 14a9 9 0 1 0-1.5-5.5" />
  </svg>
);

const RequirementsGuardIcon = () => (
  <svg {...iconProps}>
    <path d="M12 3l8 3v6c0 5-3.4 8.4-8 9-4.6-.6-8-4-8-9V6l8-3z" />
    <path d="M9.5 12.5l1.8 1.8 3.4-3.6" />
  </svg>
);

const NotificationsIcon = () => (
  <svg {...iconProps}>
    <path d="M18 16v-5a6 6 0 1 0-12 0v5l-2 2h16l-2-2z" />
    <path d="M10 19a2 2 0 0 0 4 0" />
  </svg>
);

const SIDEBAR_ICONS = {
  'app-review': MonitorIcon,
  messages: MessagesIcon,
  profile: AccountIcon,
  'job-description': JobDescriptionIcon,
  'create-accounts': CreateAccountsIcon,
  interviewers: InterviewersIcon,
  onhold: OnHoldIcon,
  'job-offer': JobOfferIcon,
  hired: HiredIcon,
  pooling: PoolingIcon,
  'passed-interview': PassedInterviewIcon,
  'failed-interview': FailedInterviewIcon,
  'application-retracted': RetractedIcon,
  'app-requirements-guard': RequirementsGuardIcon,
  notifications: NotificationsIcon,
};

export const SidebarNavIcon = ({ id, className = 'menu-item-icon' }) => {
  const Icon = SIDEBAR_ICONS[id];
  if (!Icon) return null;

  return (
    <span className={className} aria-hidden="true">
      <Icon />
    </span>
  );
};

export default SidebarNavIcon;
